module.exports = __webpack_public_path__ + "static/features-playbook-d7d8cbdc05b525d59363fb72ede1c29a.png";